import { UrlController } from './url.controller';
import { PhFiltersAction, PhFiltersDataStatus, PhFiltersService } from './ph-filters.service';
import { PhFiltersDataEmitter } from '@shared/components/ph-filters/ph-filters.service';
import { UntypedFormGroup } from '@angular/forms';
import { BaseProjectComponent } from '@layouts/default/layouts/logged/pages/project/components/base-project.component';
import { Directive } from '@angular/core';

@Directive()
export class PHFiltersController extends BaseProjectComponent {
  data: any = [];

  urlController: UrlController = null;
  loading: boolean = false;

  constructor(private phFiltersService: PhFiltersService, public form: UntypedFormGroup) {
    super();
    this.urlController = new UrlController();
    this.initListener();
  }

  initListener() {
    const eventSub = this.phFiltersService.filtersEmitter.subscribe(
      (event: PhFiltersDataEmitter) => {
        switch (event.action) {
          case PhFiltersAction.LOAD_MORE:
            this.data = [];
            this.phFiltersService.setParams({
              page: +this.phFiltersService.params.page + 1,
            });
            this.getMoreData();
            break;
          case PhFiltersAction.UPDATE_PARAMS:
            this.data = [];
            this.phFiltersService.setParams(event.params);
            this.getData();
            break;
        }
      }
    );
    this.someSubscriptions.add(eventSub);
  }

  getMoreData() {
    this.getData(true);
  }

  getData(loadMore = false) {
    if (this.loading) {
      return;
    }
    this.loading = true;
    this.urlController.updateUrl(this.phFiltersService.params);
    const sub = this.phFiltersService.get().subscribe(
      (el) => {
        this.data = [...this.data, ...el.data.data];
        el.data.data = this.data;
        this.loading = false;

        const pack = new PhFiltersDataEmitter({
          action: loadMore ? PhFiltersAction.MORE_DONE : PhFiltersAction.LOADING_DATA,
          records: el.data,
          status: PhFiltersDataStatus.SUCCESS,
        });
        this.phFiltersService.filtersEmitter.emit(pack);
      },
      (error) => {
        this.loading = false;
        this.phFiltersService.filtersEmitter.emit(
          new PhFiltersDataEmitter({
            action: loadMore ? PhFiltersAction.MORE_DONE : PhFiltersAction.LOADING_DATA,
            records: error.data,
            status: PhFiltersDataStatus.ERROR,
          })
        );
      }
    );
    this.someSubscriptions.add(sub);
  }

  isNextPageLoad(params: object): boolean {
    return Object.keys(params).length === 1 && 'page' in params;
  }
}
